import { useEffect, useState } from "react";
import MatchDetails from './MatchDetails.jsx'
import Pagination from './pagination/Pagination.jsx'
import MatchesDay from './MatchesDay.jsx'
import { ListMatchesPerDay } from "../repo/MatchesRepo.js";

export default function MatchesList({groupId, matchesPage}) {
  const [matches, setMatches] = useState([])
  const [pagination, setPagination] = useState(null)
  const [currentMatchesPage, setCurrentMatchesPage] = useState(matchesPage || 1)
  const [selectedDay, setSelectedDay] = useState(null)

  function handlePaginationClick(newMatchesPage) {
    setCurrentMatchesPage(newMatchesPage)

    window.history.replaceState(null, "Bolão", "?group_id=" + groupId + "&matches_page=" + newMatchesPage)
  }

  function handleDayClick(day) {
    setSelectedDay(day)
  }

  async function loadMatches(groupId, matchesPage, selectedDay) {
    const resData = await ListMatchesPerDay(groupId, matchesPage, selectedDay)

    setMatches(resData.data)
    setPagination(resData.pagination)
  }

  useEffect(() => {
    if (groupId && selectedDay) {
      loadMatches(groupId, currentMatchesPage, selectedDay)
    }
  }, [groupId, currentMatchesPage, selectedDay])

  return (
    <div className="flex flex-col">
      <MatchesDay groupId={groupId} onDayClick={handleDayClick}/>
      {selectedDay && matches.length > 0 &&
      <>
        {matches.map((match) => (
          <MatchDetails key={"match-details-" + groupId + "|" + match.match.id} groupId={groupId} match={match.match} bet={match.bet}/>
        ))}
      </>
      }

      <Pagination pagination={pagination} onPaginationClick={handlePaginationClick}/>
    </div>
  )
}
